export const release = "PRO"; //Just change this to switch between API URLs
//export const APIServerURL = 'http://localhost:5000/api';
//export const APIServerURL = 'http://16.78.24.227:8080/api';
//15.218.153.69
//release === 'DEV' ? 'http://16.78.24.227:8080/api' : 'http://localhost:5000/api' ;
//export const APIServerURL = 'http://cnvmdemowebdev.americas.hpqcorp.net:8080/DemoPortal/api';
//export const APIServerURL = 'https://hpedemoportal-itg.ext.hpe.com:4433/DemoPortal/api';
export const APIServerURL =
  release === "PRO"
    ? "https://hpedemoportal.api.ext.hpe.com/DemoPortal/api"
    : release === "DEV"
      ? "https://10.4.3.89:4334/api"
      : release === "ITG"
        ? "https://hpedemoportal-itg.api.ext.hpe.com/DemoPortal/api"
        : release === "DEV_OLD"
          ? "http://15.218.153.70/TokenProvider/api"
          : "http://localhost:5000/api";

export const UIServerURL =
  release === "PRO"
    ? "https://hpedemoportal.ext.hpe.com"
    : release === "DEV"
      ? "https://10.4.3.90"
      : release === "HPED"
        ? "https://hpedemoportal-itg.api.ext.hpe.com/DemoPortal/api"
        : release === "ITG"
          ? "https://hpedemoportal-itg.ext.hpe.com"
          : "http://localhost:5000/api";

export const LogoutOktaURL =
  release === "PRO"
    ? "https://auth.hpe.com/oauth2/aus43pf0g8mvh4ntv357/v1/logout"
    : "https://auth-itg.hpe.com/oauth2/austpzqbr10S8JwpZ0h7/v1/logout";

export const envKey =
  release === "ITG"
    ? "33caa65b-bc35-437f-9b23-7c623c845d76"
    : release === "DEV"
      ? "33caa65b-bc35-437f-9b23-7c623c845d76"
      : release === "PRO"
        ? "7b97f24e-052a-4171-b57b-fffed408a626"
        : release === "DEV2"
          ? "123456789ABCDE!@#$%"
          : "123456789ABCDE!@#$%";
export const TokenRefreshInterval = 30000;
export const OnDemandRefreshInterval = 30000;
export const PostAccessLogEndpoint = "/AccessLog/SubmitAccessLog";
let styleInjected = false;

export function injectStyle() {
  if (!styleInjected) {
    // Remove large X in IE11 and Edge
    const style = document.createElement("style");
    style.innerHTML = "::-ms-clear {display: none;}}";
    document.body.appendChild(style);
    styleInjected = true;
  }
}

export function debugLog(text, env) {
  if (env === release) {
    console.log(text);
  } else if (env === undefined && release === "DEV") {
    console.log(text);
  }
}

export function callApiGetJsonwithEP(endpoint, token) {
  let config = {};

  if (token) {
    config = {
      headers: { Authorization: `Bearer ${token}` },
    };
  }
  /*else {
        throw "No token sent!"
    }*/

  return fetch(endpoint, config)
    .then((response) => response.json().then((json) => ({ json, response })))
    .then(({ json, response }) => {
      if (!response.ok) {
        return Promise.reject(json);
      }

      return json;
    })
    .catch((err) => console.log(err));
}

export function callApiGetJson(endpoint, token) {
  let config = {};

  if (token) {
    config = {
      headers: { Authorization: `Bearer ${token}` },
    };
  }
  /*else {
        throw "No token sent!"
    }*/

  return fetch(APIServerURL + endpoint, config)
    .then((response) => response.json().then((json) => ({ json, response })))
    .then(({ json, response }) => {
      if (!response.ok) {
        return Promise.reject(json);
      }

      return json;
    })
    .catch((err) => console.log(err));
}

export function callApiValidatePort(endpoint) {
  return fetch(APIServerURL + endpoint)
    .then(function (response) {
      return response;
    })
    .then(function (data) {
      console.log(data.text);
      if (data.status !== 200) {
        return "Error";
      } else {
        return "success";
      }
    })
    .catch((err) => console.log(err));
}

export function callApiPostJson(endpoint, postData, token) {
  let config = {};

  if (token) {
    config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(postData),
    };
  } else {
    config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    };
  }

  return fetch(APIServerURL + endpoint, config)
    .then((response) => response.json().then((json) => ({ json, response })))
    .then(({ json, response }) => {
      if (!response.ok) {
        return Promise.reject(json);
      }
      return json;
      //return json
    })
    .catch((err) => err);
}

export function callApiPostString(endpoint, postData, token) {
  let config = {};

  if (token) {
    config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(postData),
    };
  } else {
    throw "No token sent!";
  }

  return fetch(APIServerURL + endpoint, config)
    .then((response) => response.text())
    .then((text) => {
      return text;
    })
    .catch((err) => console.log(err));
}

export function callApiBlob(endpoint, token) {
  let config = {};

  if (token) {
    config = {
      headers: { Authorization: `Bearer ${token}` },
    };
  } else {
    throw "No token sent!";
  }

  return fetch(APIServerURL + endpoint, config)
    .then((response) => response.blob().then((blob) => ({ blob, response })))
    .then(({ blob, response }) => {
      if (!response.ok) {
        return Promise.reject(blob);
      }
      return blob;
    })
    .catch((err) => err);
}

export function callApiText(endpoint, token) {
  let config = {};

  if (token) {
    config = {
      headers: { Authorization: `Bearer ${token}` },
    };
  }
  /*else {
        throw "No token sent!"
    }*/

  return fetch(APIServerURL + endpoint, config)
    .then((response) => response.text().then((text) => ({ text, response })))
    .then(({ text, response }) => {
      if (!response.ok) {
        return Promise.reject(text);
      }

      return text;
    })
    .catch((err) => err);
}

export function postFormData(endpoint, formData, token) {
  let config = {};

  if (token) {
    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    };
  } else {
    config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
      body: formData,
    };
  }

  return fetch(APIServerURL + endpoint, config)
    .then((response) => response.json().then((json) => ({ json, response })))
    .then(({ json, response }) => {
      if (!response.ok) {
        return Promise.reject(json);
      }
      return json;
      /*if (response.ok) {

                return json;
            }

            if (response.status == 400)
                //throw new Error(json.DetailedErrorInfo);
                //console.log(json.DetailedErrorInfo);
               return Promise.reject(json.DetailedErrorInfo);
*/
      //}).catch(err => alert(JSON.stringify(err.DetailedErrorInfo)))
    })
    .catch((err) => err);
}

export function logAccess(contentID, contentType, action, siteLocation, token) {
  //let config = {};
  let data = {
    AccessLog_ContentID: contentID,
    AccessLog_ContentType: contentType,
    AccessLog_Action: action,
    AccessLog_SiteLocation: siteLocation,
  };

  return callApiPostJson(PostAccessLogEndpoint, data, token).then(
    (response) => {
      debugLog(response);
    },
  );
  //    console.log(response))
}

export function validateEmail(email) {
  var re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function validatePassword(password) {
  var re =
    /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()+=-\?;,./{}|\":<>\[\]\\\' ~_]).{8,}/;
  return re.test(password);
}
